import React from 'react';
import PropTypes from 'prop-types';

const YFTextArea = ({ test_id, disabled, type, label, name, placeholder, register, error }) => {
    return (
        <>
            <label htmlFor={name}>{label}</label>
            <textarea
                test_id={test_id}
                disabled={!disabled}
                type={type}
                name={name}
                placeholder={placeholder}
                ref={register}
            />
        </>
    );
};
YFTextArea.propTypes = {
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
};
YFTextArea.defaultProps = {
    disabled: true,
};
export default YFTextArea;
